import { resets } from '@ui/css';
import { Radio } from '@ui/kit';
import { wrapper, labelWrapper, teaser } from './atom.font-radio.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FontRadio(props) {
  return /*#__PURE__*/jsxs("label", {
    className: wrapper,
    children: [/*#__PURE__*/jsx("input", {
      type: "radio",
      className: resets.screenReaderOnlyCls,
      checked: props.checked,
      onChange: props.onChange
    }), /*#__PURE__*/jsxs("div", {
      className: labelWrapper,
      children: [/*#__PURE__*/jsx(Radio, {
        toggled: props.checked
      }), /*#__PURE__*/jsx("span", {
        children: props.label
      })]
    }), /*#__PURE__*/jsx("span", {
      "aria-hidden": true,
      className: teaser,
      "data-font-variant": props.font,
      children: props.teaser
    })]
  });
}

export { FontRadio };
//# sourceMappingURL=atom.font-radio.js.map
